import {PriceModel} from './Price.model';
import {PriceSummary} from '@wix/ecom_current-cart';

export class PriceSummaryModel {
  public subtotal: PriceModel;
  public shipping: PriceModel;
  public tax: PriceModel;
  public discount: PriceModel;
  public total: PriceModel;
  public additionalFees: PriceModel;

  constructor(params: PriceSummaryModel) {
    this.subtotal = params.subtotal;
    this.shipping = params.shipping;
    this.tax = params.tax;
    this.discount = params.discount;
    this.total = params.total;
    this.additionalFees = params.additionalFees;
  }

  public static fromSDK(priceSummary: PriceSummary) {
    return new PriceSummaryModel({
      subtotal: PriceModel.fromSDK(priceSummary.subtotal),
      total: PriceModel.fromSDK(priceSummary.total),
      tax: PriceModel.fromSDK(priceSummary.tax),
      discount: PriceModel.fromSDK(priceSummary.discount),
      additionalFees: PriceModel.fromSDK(priceSummary.additionalFees),
      shipping: PriceModel.fromSDK(priceSummary.shipping),
    });
  }
}
